// extracted by mini-css-extract-plugin
module.exports = {"questions":"Faq-module--questions--3AtYp","questionsBackground":"Faq-module--questions-background--1GbSu","titleSection":"Faq-module--title-section--24So5"};